const Spinner = () => (
    <div className="flex flex-col justify-center items-center h-[55vh]">
        <div className="w-14 h-14 border-[6px] border-primary-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-2 text-grey-text">Loading data...</p>
    </div>
)

export default Spinner;